import { useMemo } from "react";
import type { DateTime } from "luxon";
import { buildTileUrl, buildBaseTileFilterParams } from "@/utils/tileUrl";
export const JunctionTileSource = {
  markers: "markers",
  gates: "gates",
  segments: "segments"
} as const;
export type JunctionTileSource = (typeof JunctionTileSource)[keyof typeof JunctionTileSource];
const JUNCTION_DATA_SOURCES = {
  [JunctionTileSource.markers]: "get_junctions",
  [JunctionTileSource.gates]: "get_junction_gates",
  [JunctionTileSource.segments]: "get_junction_segments"
} satisfies Record<JunctionTileSource, string>;
export function useJunctionTileUrl(source: JunctionTileSource, options?: {
  junctionId?: number | null;
  startTimestamp?: DateTime | null;
  endTimestamp?: DateTime | null;
}) {
  const junctionId = options?.junctionId;
  const startTimestamp = options?.startTimestamp;
  const endTimestamp = options?.endTimestamp;
  return useMemo(() => {
    const params = buildBaseTileFilterParams({
      startTimestamp,
      endTimestamp
    });
    if (junctionId != null) {
      params.unshift(`junctionId=${junctionId}`);
    }
    return buildTileUrl(JUNCTION_DATA_SOURCES[source], params);
  }, [source, junctionId, null, startTimestamp, endTimestamp]);
}